































import { Component, Vue, Watch } from "vue-property-decorator";
import { padHeadPanel2 } from "@/components";
import storeInfo from "./components/storeInfo.vue";
import sySetting from "./components/sySetting.vue";
import xtSetting from "./components/xtSetting.vue";
import mmSetting from "./components/mmSetting.vue";
import zfSetting from "./components/zfSetting.vue";
import pjSetting from "./components/pjSetting.vue";
@Component({
  components: {
    padHeadPanel2,storeInfo,sySetting,xtSetting,mmSetting,zfSetting,pjSetting
  },
})
export default class setting extends Vue {
  active = 'dpxx';

  userInfo = {};

  public $refs: {};
  activated() {
    console.log('activated');
    
      this.active ='dpxx';
      if (this.$route.query.tag && this.$route.query.tag == "pjsz") {
        this.active = "pjsz";
      }
      this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
  }
  created() {
    console.log('created');
    
    // if (this.$route.query.tag && this.$route.query.tag == "pjsz") {
    //   this.active = "pjsz";
    // }
    // this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
  }

  /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/setting.vue